import { render } from "./Footer.vue?vue&type=template&id=26069138"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=26069138&lang=scss"

import exportComponent from "/Users/hxp/Workspace/bintangmas-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__